import React from "react";
import BannerCarousel from "../../components/BannerCarousel";

const images = [
  "https://img5.hkrtcdn.com/26593/bnr_2659274_o.jpg",
  "https://img9.hkrtcdn.com/22801/bnr_2280038_o.jpg",
  "https://img9.hkrtcdn.com/26434/bnr_2643348_o.jpg",
  "https://img1.hkrtcdn.com/26434/bnr_2643350_o.jpg",
];

const CarouselSix = () => <BannerCarousel images={images} />;

export default CarouselSix;
